import { jsx } from 'react/jsx-runtime';
import { Icon } from '@zapier/design-system';
import { useContext } from 'react';
import { ComboBoxStateContext, Button } from 'react-aria-components';

const clearButton = "_clear-button_lmfsv_1";
const iconWrapper = "_icon-wrapper_lmfsv_26";
const styles = {
	clearButton: clearButton,
	iconWrapper: iconWrapper
};

const TypeaheadRightSlot = ({ iconRight, isTypeaheadDisabled = false, size }) => {
  const state = useContext(ComboBoxStateContext);
  const showClearSelectionButton = (state === null || state === void 0 ? void 0 : state.inputValue) && !isTypeaheadDisabled;
  return showClearSelectionButton ? jsx("div", { className: styles.iconWrapper, "data-size": size, "data-zds": true, children: jsx(Button, {
    "aria-label": "Clear selection",
    className: styles.clearButton,
    "data-size": size,
    "data-zds": true,
    onPress: () => state === null || state === void 0 ? void 0 : state.setSelectedKey(null),
    // Don't inherit default RAC Button behavior from RAC ComboBox.
    slot: null,
    children: jsx(Icon, { name: "arrowRefresh", color: "StrokeStronger", size: "24px" })
  }) }) : iconRight && jsx("div", { className: styles.iconWrapper, "data-size": size, "data-zds": true, children: jsx(Icon, { name: iconRight, size: "24px" }) });
};

export { TypeaheadRightSlot };
//# sourceMappingURL=TypeaheadRightSlot.es.js.map
